var render = function render(_c,_vm){return _vm._m(0)
}
var staticRenderFns = [function (_c,_vm){return _c('div',{staticClass:"news-filter__banners-ads"},[_c('div',{staticClass:"banner-ad"},[_c('img',{attrs:{"src":"https://photos.clutch.ca/af84be20-558e-11e9-8ddd-e389f2c9913a-medium.jpg","alt":""}})])])
}]

export { render, staticRenderFns }